const WEBCHAT_COLOR = {
  HECTOROUND_STYLE: [
    { name: 'develop', brands: [2] }, // 클게_데브1
    { name: 'develop2', brands: [5458] }, // 오근혁브랜드 수정
    { name: 'staging', brands: [5638, 5545] }, // 클라우드게이트QA
    { name: 'production', brands: [7584, 7597, 7598, 5706] } // ROUND, 클게_QA
  ]
};

const getHectoRoundList = () => {
  return WEBCHAT_COLOR.HECTOROUND_STYLE.find((data) => data.name === process.env.VUE_APP_NODE_ENV);
};

export { getHectoRoundList };
